
















import { defineComponent } from '@vue/composition-api';
import ProgressCircularComponent from '@/components/Common/molecules/ProgressCircular.vue';
import AnalysisPlanTableComponent from '@/components/Management/molecules/AnalysisPlanTable.vue';
import { useCompanyPlan } from '@/composables/store/Management/AnalysisPlan/useCompanyPlan';

export default defineComponent({
    components: {
        ProgressCircular: ProgressCircularComponent,
        AnalysisPlanTable: AnalysisPlanTableComponent,
    },
    setup() {
        const { isPlanFetchListProgressing } = useCompanyPlan();

        return {
            isPlanFetchListProgressing,
        };
    },
});
